import sbi1 from '../assets/projects/video/sbi1.gif';
import sbi2 from '../assets/projects/video/sbi2.gif';
import quirk1 from '../assets/projects/video/quirk1.gif';
import quirk2 from '../assets/projects/video/quirk2.gif';
import newswall1 from '../assets/projects/video/newswall1.gif';
import newswall2 from '../assets/projects/video/newswall2.gif';
import helpi1 from '../assets/projects/video/helpi1.gif';
import helpi2 from '../assets/projects/video/helpi2.gif';
import mumble1 from '../assets/projects/video/mumble1.gif';
import mumble2 from '../assets/projects/video/mumble2.gif';
import csc1 from '../assets/projects/video/csc1.gif';
import csc2 from '../assets/projects/video/csc2.gif';
import sbi_cover from '../assets/projects/covers/sbi_cover.png';
import quirk_cover from '../assets/projects/covers/quirk_cover.png';
import newswall_cover from '../assets/projects/covers/newswall_cover.png';
import helpi_cover from '../assets/projects/covers/helpi_cover.png';
import mumble_cover from '../assets/projects/covers/mumble_cover.png';
import csc_cover from '../assets/projects/covers/csc_cover.png';

export const projects = [
    {
        title: "SBIKTM",
        type: "Full Stack",
        tech: "MERN",
        role: "Frontend & Backend",
        cover: sbi_cover,
        img1: sbi1,
        img2: sbi2,
        year: 2023,
        details: "Designed for seamless full-stack performance. My role encompassed both frontend and backend responsibilities, resulting in a harmonious integration of technologies. The project centers around an innovative solution to streamline and monitor daily transactions at an SBI kiosk. Through meticulous development, I created an intuitive platform that empowers administrators and employees alike to effortlessly manage cash and limit data. The dynamic nature of the portal ensures that updates and additions trigger automatic adjustments to relevant information. Leveraging the power of the MERN stack, I successfully brought this vision to life.",
        link: "https://csc-sbi.netlify.app/"
    },
    {
        title: "Quirk",
        type: "Full stack",
        tech: "MERN",
        role: "Frontend & Backend",
        cover: quirk_cover,
        img1: quirk1,
        img2: quirk2,
        year: 2023,
        details: " A captivating MERN-based masterpiece where I took on the role of both frontend and backend developer, resulting in a harmonious blend of cutting-edge technologies. This dynamic to-do web app redefines task management with features like drag-and-drop functionality, intelligent task filtering by year and month, and the ability to display tasks within selected date ranges. I seamlessly integrated APIs using Node.js to fetch, post, delete, and update data within the database, while also adding a touch of visual brilliance with Chart.js for captivating data visualizations. QUIRK is more than just a to-do app; it's an unforgettable journey of productivity and innovation.",
        link: "https://bib-todo.netlify.app/"
    },
    {
        title: "Newswall",
        type: "Subscription model",
        tech: "HTML, CSS, JS, PHP",
        role: "Frontend & Backend",
        cover: newswall_cover,
        img1: newswall1,
        img2: newswall2,
        year: 2022,
        details: "Delve into the world of innovation with an enchanting e-commerce website designed around an exclusive online subscription model, created during the enriching journey of my 3rd semester in MCA. This captivating project showcases two distinct portals, each offering a unique perspective: one for the discerning user and the other for the visionary admin. Seamlessly blending PHP, HTML, CSS, and Javascript technologies, this project breathes life into the realm of digital journalism, granting users access to a treasure trove of exclusive news articles curated by the dedicated admin.",
        link: "http://newswall.epizy.com/?i=1"
    },
    {
        title: "Helpi",
        type: "Web-app",
        tech: "HTML, CSS, PHP",
        role: "Frontend",
        cover: helpi_cover,
        img1: helpi1,
        img2: helpi2,
        year: 2021,
        details: "shines as a collaborative masterpiece, representing my inaugural foray into web application development during the first semester. A testament to teamwork, I embarked on this journey alongside two cherished friends. Together, we crafted a multifaceted web application, boasting three pivotal modules: the astute Admin, the discerning Customers, and the dedicated Service Providers. The project seamlessly integrates HTML, CSS, Javascript, PHP, and the robust MySQL database to create a dynamic and engaging user experience. HELPI is not just a project; it's a harmonious symphony of creativity, friendship, and innovation.",
        link: "https://github.com/Bibhuni/homeservice"
    },
    {
        title: "Mumble",
        type: "Full stack",
        tech: "MERN",
        role: "Frontend",
        cover: mumble_cover,
        img1: mumble1,
        img2: mumble2,
        year: 2022,
        details: "Stands as a testament to my journey into the world of full-stack web development during my second semester, where I collaborated with a dear friend to craft a web application of remarkable ingenuity. This project boasts two integral modules: the astute Admin and the valued Users, with a seamlessly functioning backend database. Leveraging the power of the MERN stack, MUMBLE encapsulates the essence of modern web development, providing invaluable insights into the workings of React. Beyond a mere project, it embodies a symphony of innovation and collaboration.",
        link: "https://github.com/Bibhuni/mumble"
    },
    {
        title: "CSC",
        type: "Website design",
        tech: "HTML, CSS",
        role: "Frontend",
        cover: csc_cover,
        img1: csc1,
        img2: csc2,
        year: 2021,
        details: "Represents my initial steps into the realm of web design, where I honed my skills in HTML and CSS, laying the foundation for future adventures. This delightful project emerged as my maiden foray into PHP, marking a significant milestone in my learning journey. It takes the form of a dynamic slot booking website, skillfully crafted with PHP and linked to a meticulously structured database. This experience proved invaluable, providing me with a solid foundation for subsequent minor projects.",
        link: "https://csc-khalisahi.netlify.app/"
    }
]